module.exports = __webpack_public_path__ + "img/live-content.3eec7ffe.png";